import {makeGetNetworkFilters} from 'main/factories/usecases/private/guide-flow/remote-medical-guide/get-network-filters';

async function getNetworkFilters() {
	const response = await makeGetNetworkFilters().get();
	if (!response.tipoRede || response.tipoRede.length === 0) {
		return [];
	}
	return response.tipoRede;
}

export {getNetworkFilters};
